<template>

  <div>
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaReceitas_lVeiculo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="3">          
            <v-select 
                label="placa"
                :filter="pesquisarVeiculo"
                :options="listaVeiculos" 
                :reduce="v => v.idVeiculo" 
                v-model="filtro.idVeiculo"                                   
                class="v-select w-full">
            <template #option="{  placa, modelo, labelVeiculo, marcaModulo  }">
                <small :style="{ color: getCorMarcaModulo(marcaModulo) }"><strong> {{modelo}} </strong>  
                <em> - {{placa}} </em> <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template> 
            <template #selected-option="{ placa, labelVeiculo  }">                          
                <small style="font-size:0.70vw">{{placa}} <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template>
            <template #no-options="">
                {{ $t('NenhumVeiculoEncontrado') }}
            </template>
          </v-select>  
        </vs-col> 
         <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("Periodo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">                
          <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
          <label class="vs-input--label">à</label>
          <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
        </vs-col>  

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
          </vx-tooltip>
          <vx-tooltip :text="$t('LimparFiltros')">              
            <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
          </vx-tooltip>          
          <vx-tooltip :text="$t('ExportarParaCSV')">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vx-tooltip>
        </vs-col>
      </vs-row>
      
    </vx-card>

     <vx-card>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="25"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationAutoPageSize="true"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
          <div class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg flex items-center justify-between font-medium text-sm">
            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ dadosDaGrid.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : dadosDaGrid.length }} de {{ dadosDaGrid.length }}</span>              
          </div>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="text-sm" />
        </vs-col>
      </vs-row>
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"

import { AgGridVue } from "ag-grid-vue"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

import '@/assets/concept/scss/tabelaBasica.scss'
import 'vue-select/dist/vue-select.css';
import generico from '@/generico.js'

const URL_SERVLET = "/rest/EventoMonitriip/Listar";
const NAME_ROUTE_EDIT = "controle-viagens-monitriip-edit";

export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro: {idVeiculo: null, dataInicio: null, dataFim: null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'VEICULO', field: 'veiculo.placa' },
            { headerName: 'IMEI', field: 'imei' },
            { headerName: 'DATA/HORA', field: 'dataHora', valueGetter: function(params) { return (params.data.dataHora ? generico.formatarDataHoraYYYYMMDDHHMMSS(params.data.dataHora) : '-')}  },
            { headerName: 'OPERAÇÃO', field: 'descricaoOperacao' },    
            { headerName: 'TIPO EVENTO', field: 'tipoEventoMonitriip' },    
            { headerName: 'AUTORIZAÇÃO VIAGEM', field: 'autorizacaoViagem' },
            { headerName: 'MOTIVO PARADA', field: 'motivoParada' },
            { headerName: 'DATA RECEBIMENTO', field: 'dataRecebimento', valueGetter: function(params) { return (params.data.dataRecebimento ? generico.formatarDataHoraYYYYMMDDHHMMSS(params.data.dataRecebimento) : '-')}  },
            { headerName: 'ENVIO ANTT', field: 'dataEnvioANTT', valueGetter: function(params) { return (params.data.dataEnvioANTT ? generico.formatarDataHoraYYYYMMDDHHMMSS(params.data.dataEnvioANTT) : '-')}  },
            { headerName: 'PROCESSADO', field: 'processado', 
              valueGetter: function(params) { return ( params.data.processado ? 'SIM' : 'NÃO'); } },
          ]
      },
       configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
           dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },
      dadosDaGrid: [],
      totalRegistros: 0 ,
      listaVeiculos: []          
    }
  },  
  computed: {    
    filterSectionHeight() {
      return 320;   
    },    
    paginationPageSize() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetPageSize()
      else return 200  
    },
    totalPages() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.configuracaoGrid.gridApi.paginationGoToPage(val - 1)
      }
    },    
  },
  methods: {
    getCorMarcaModulo(marcaModulo) {
      return generico.getCorMarcaModulo(marcaModulo);
    },
    fetchVeiculos() {      
        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('funcionalidade', 'MONITRIIP');

        axios.get("/RecuperarVeiculosAtivosCliente", {
                params, 
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {            
                this.$router.push({ path: '/login' });
            } else {
                this.listaVeiculos = response.data;                           
            }        
        })
        .catch((error) => { 
            /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchVeiculos - " + error); 
        })       

    },  
    pesquisarVeiculo(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (veiculo) {
              return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
              ) ;
      })
    },
    limparFiltros() {
      this.filtro = { idVeiculo: null, dataInicio: null, dataFim: null };    
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);       
    },
    fetchLista(pFiltro) {   
      this.$vs.loading();  
      this.currentPage = 1; 
      const params = new URLSearchParams();      
      params.append('pagina', -1);

      if (pFiltro.idVeiculo) {
        params.append('idVeiculo', pFiltro.idVeiculo);        
      }

       if (pFiltro.dataInicio) {        
        params.append('dataInicioPesquisa', generico.formatarTimestampParaYMD(pFiltro.dataInicio*1000));
      }

      if (pFiltro.dataFim) {
        params.append('dataFimPesquisa', generico.formatarTimestampParaYMD(pFiltro.dataFim*1000));  
      }

           
      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.totalRegistros = response.data.Resultado.quantidade;
              if (response.data.Resultado.quantidade > 1) {
                  this.dadosDaGrid = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.dadosDaGrid = [];
                  this.dadosDaGrid.push(response.data.Resultado.lista.item);
              } else {
                  this.dadosDaGrid = [];
              }              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },    
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'EventosMonitriip.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   

    if (this.$store.getters.filtroEventosMonitriip) {      
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroEventosMonitriip));
    }  else {
        var date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.filtro.dataInicio = String(firstDay.getTime()/1000);
        this.filtro.dataFim = String(lastDay.getTime()/1000);
    }

    this.fetchLista(this.filtro);
    this.fetchVeiculos();
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'eventos-monitriip' , filtro: this.filtro});
  },
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 305px);
  }
</style>